import styled from "styled-components";

export const BackContainer = styled.div`
  margin: 0 ${({ theme }) => theme.old.sizes.sidesMargin.large};
  margin-bottom: 32px;

  ${({ theme }) => theme.old.breakpoints.isTab} {
    margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.small};
  }
`